import { IState } from './Worksale.reducer';

const WorksaleId = (s: IState) => s.WorksaleId;
const CustomerId = (s: IState) => s.CustomerId;
const salesEntity = (s: IState) => s.salesEntity;
const WorksaleLineId = (s: IState) => s.WorksaleLineId;
const WorksaleDeliveryId = (s: IState) => s.WorksaleDeliveryId;
const WorksaleDeliverySummary = (s: IState) => s.worksaleDeliverySummary;
const ProcessingProblemsDialogOpen = (s: IState) => s.processingProblemsDialogOpen;
const ProcessingProblemsDialog = (s: IState) => s.processingProblemsDialog;
const worksaleLookupPanelOpen = (s: IState) => s.worksaleLookupPanelOpen;

const Selectors = {
  WorksaleId,
  CustomerId,
  salesEntity,
  WorksaleLineId,
  WorksaleDeliveryId,
  ProcessingProblemsDialogOpen,
  ProcessingProblemsDialog,
  WorksaleDeliverySummary,
  worksaleLookupPanelOpen
};

export default Selectors;
